module.exports = __webpack_public_path__ + "img/2.9faee90b.jpg";